import React, { useState } from 'react';
import BlogCard from '../components/BlogCard';
import { blogPosts, categories } from '../data';
import '../CSS/Blog.css';

const Blog = () => {
  const [activeTag, setActiveTag] = useState('All');
  const [search, setSearch] = useState('');

  const allTags = ['All', ...categories.map(c => c.label)];

  const filtered = blogPosts.filter(post => {
    const matchesTag = activeTag === 'All' || post.tags.includes(activeTag);
    const matchesSearch = !search || 
      post.title.toLowerCase().includes(search.toLowerCase()) ||
      post.excerpt.toLowerCase().includes(search.toLowerCase());
    return matchesTag && matchesSearch;
  });

  return (
    <main className="blog-page">
      <div className="container">
        <div className="blog-page__hero">
          <span className="section-label">All Articles</span>
          <h1 className="blog-page__title">The Blog</h1>
          <p className="blog-page__subtitle">
            Deep dives into React, Node.js, TypeScript and modern web development.
          </p>

          <div className="blog-page__search-wrap">
            <svg className="blog-page__search-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
            </svg>
            <input
              type="text"
              placeholder="Search articles..."
              className="blog-page__search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        <div className="blog-page__filters">
          {allTags.map(tag => (
            <button
              key={tag}
              className={`blog-filter-btn ${activeTag === tag ? 'blog-filter-btn--active' : ''}`}
              onClick={() => setActiveTag(tag)}
            >
              {tag}
            </button>
          ))}
        </div>

        {filtered.length > 0 ? (
          <div className="blog-grid">
            {filtered.map((post) => (
              <BlogCard key={post.id} post={post} />
            ))}
          </div>
        ) : (
          <div className="blog-page__empty">
            <span>🔍</span>
            <p>No articles found matching your search.</p>
            <button onClick={() => { setSearch(''); setActiveTag('All'); }} className="btn btn--secondary">
              Clear filters
            </button>
          </div>
        )}
      </div>
    </main>
  );
};

export default Blog;
